import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    instructions: {
      width: '100%',
      background: theme.palette.primary.light,
      padding: '8px 16px 8px 24px',
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
      borderRadius: 8,
      position: 'relative',
      display: 'flex',
    },
    sideBorder: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 8,
      height: '100%',
      background: theme.palette.primary.main,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
    instructionsWrapper: {
      width: '100%',
    },
    instructionsInner: {
      width: '100%',
    },
    instructionsTitle: {
      margin: 0,
      marginBottom: 8,
      color: theme.palette.primary.main,
      fontWeight: 300,
      fontSize: 14,
      lineHeight: '16px',
      letterSpacing: '-0.04em',
    },
    instructionsBody: {
      fontStyle: 'normal',
      fontWeight: 400,
      color: theme.palette.common.black,
      margin: 0,
      fontSize: 16,
      lineHeight: '24px',
    },
  }
})
